import SearchIcon from '@mui/icons-material/Search';

export const SearchForm = ({ handleSearch, isLoading }) => {
    return (
        <form onSubmit={handleSearch}>
            <div className="inputGroup">
                <SearchIcon className="searchIcon"/>
                
                <input 
                    type="text" 
                    placeholder="Type username..." 
                    name="username" 
                    autoFocus
                />
            </div>

            <button disabled={isLoading} className="searchBtn" type="submit">
                {isLoading ? "Searching..." : "Search"}
            </button>
        </form>
    );
};